// Backend ADR 24.9.26ab D4/D6 — the two `/email/preferences` routes the page reads
// and writes.
//
// In the feature rather than in `api/` (the `reminders/reminderApi.ts`
// precedent, and `api/` sits one file under its folder budget). Both calls are
// **anonymous**: the `?t=` token in the query is the whole credential, a
// signed-in bearer would add nothing, and a 401 → refresh → retry behind it
// would resume a session the reader never asked for.

import { request, requestJson } from '../../api/http'

export interface EmailPreferences {
  lifecycle_email_opt_out: boolean
}

function path(token: string): string {
  return `/email/preferences?t=${encodeURIComponent(token)}`
}

/** `GET /email/preferences?t=` — `404` (as `ApiError`) for any link that no longer works. */
export async function getEmailPreferences(token: string): Promise<EmailPreferences> {
  const body = await requestJson<unknown>(path(token), { anonymous: true })
  const optOut = (body as Partial<EmailPreferences> | null)?.lifecycle_email_opt_out
  return { lifecycle_email_opt_out: optOut === true }
}

/** `PUT /email/preferences?t=` — `204`, so bare `request`: an empty body has no JSON to decode. */
export async function putEmailPreferences(token: string, prefs: EmailPreferences): Promise<void> {
  await request(path(token), { method: 'PUT', body: prefs, anonymous: true })
}
